module.exports = __webpack_public_path__ + "static/img/zhuzhai1.28aa64f5.png";